import { SliceCaseReducers } from '@reduxjs/toolkit'
import { ProductReceiptsApiResponse } from '@repo/accounts-types'
import { ApiResponse, createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<ApiResponse<ProductReceiptsApiResponse> | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const {
  actions: bankingProductLoanReceiptsDataActions,
  reducer: bankingProductLoanReceiptsDataReducer,
} = createOperationSlice<
  ApiResponse<ProductReceiptsApiResponse> | null,
  SliceCaseReducers<GenericOperationState<ApiResponse<ProductReceiptsApiResponse> | null>>,
  { id: string }
>({
  name: '@accounts/master/list/bankingProductLoanReceipts',
  initialState,
  reducers: {},
})
